const INIT_PARAMS_STORAGE_KEY = '__telegram__initParams';

type InitParams = Record<string, string | null>;

// Разбор хеша повторяет telegram-web-app.js, чтобы получать то же значение,
// что и сам скрипт телеграма, даже если он ещё не успел загрузиться

const urlSafeDecode = (urlencoded: string) => {
  try {
    return decodeURIComponent(urlencoded.replace(/\+/g, '%20'));
  } catch {
    return urlencoded;
  }
};

const urlParseQueryString = (queryString: string) => {
  const params: InitParams = {};

  if (!queryString.length) {
    return params;
  }

  queryString.split('&').forEach((queryStringParam) => {
    const param = queryStringParam.split('=');
    const paramName = urlSafeDecode(param[0]);

    params[paramName] = param[1] == null ? null : urlSafeDecode(param[1]);
  });

  return params;
};

const urlParseHashParams = (locationHash: string) => {
  let hash = locationHash.replace(/^#/, '');

  if (!hash.length) {
    return {} as InitParams;
  }

  // Хеш без параметров — это просто путь, разбирать нечего
  if (hash.indexOf('=') < 0 && hash.indexOf('?') < 0) {
    return {} as InitParams;
  }

  // Если у мини-аппы в ссылке уже был хеш, телеграм дописывает параметры через `?`
  const qIndex = hash.indexOf('?');
  if (qIndex >= 0) {
    hash = hash.slice(qIndex + 1);
  }

  return urlParseQueryString(hash);
};

const readInitDataFromHash = () => {
  let locationHash = '';

  try {
    locationHash = window.location.hash.toString();
  } catch {
    // ignore
  }

  return urlParseHashParams(locationHash).tgWebAppData || '';
};

/** Скрипт телеграма сам складывает параметры запуска в sessionStorage — читаем то, что он положил */
const readInitDataFromStorage = () => {
  try {
    const stored = window.sessionStorage.getItem(INIT_PARAMS_STORAGE_KEY);
    const params: InitParams = stored ? JSON.parse(stored) : {};

    return params?.tgWebAppData || '';
  } catch {
    return '';
  }
};

/**
 * Телеграм кладёт tgWebAppData в хеш только при запуске мини-аппы,
 * а первый же navigate по роутеру его затирает — поэтому читаем один раз
 * на этапе загрузки модуля и дальше отдаём сохранённое значение
 */
const initDataFromHash = readInitDataFromHash();

export const getInitData = () => initDataFromHash || readInitDataFromStorage();
